(function () {
  function getProductUrl(trigger) {
    var card = trigger.closest('.ca-guide-kit-card');

    if (!card) {
      return '';
    }

    var detailsLink = card.querySelector('.ca-guide-kit-card__details[href]');
    var titleLink = card.querySelector('.ca-guide-kit-card__title a[href]');

    return (detailsLink && detailsLink.href) || (titleLink && titleLink.href) || '';
  }

  function disableGuideKitGalleries() {
    document.querySelectorAll('[data-ca-guide-kit-gallery]').forEach(function (gallery) {
      gallery.hidden = true;
      gallery.setAttribute('aria-hidden', 'true');
      gallery.remove();
    });

    document.documentElement.classList.remove('ca-guide-kit-gallery-open');

    document.querySelectorAll('[data-ca-guide-kit-gallery-open]').forEach(function (trigger) {
      trigger.removeAttribute('aria-controls');
      trigger.removeAttribute('data-ca-guide-kit-gallery-open');

      if (!trigger.matches('a')) {
        trigger.setAttribute('type', 'button');
      }

      trigger.setAttribute('aria-label', trigger.getAttribute('aria-label') || 'View product');
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.ca-guide-kit-card__kit-media');

    if (!trigger) {
      return;
    }

    var productUrl = trigger.matches('a[href]') ? trigger.href : getProductUrl(trigger);

    if (!productUrl) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    window.location.href = productUrl;
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', disableGuideKitGalleries);
  } else {
    disableGuideKitGalleries();
  }
})();
